module.exports = __webpack_public_path__ + "static/media/valor1.f84954b4.png";